import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import themeStyles from './Timeline.styles';
var DecadeContainer = themeStyles.apply(Box, 'DecadeContainer');
var Decade = function (_a) {
    var children = _a.children, gtmTags = _a.gtmTags;
    return (React.createElement(DecadeContainer, { gtmTags: gtmTags }, children));
};
export default Decade;
